import { Provider } from '@angular/core';
import {
  APPLICATION_CONFIG,
  USER_NAVIGATOR,
  USER_NOTIFIER,
  USER_REPORT_FILENAME,
  USER_SELF_SERVICE,
  USER_SERVICE,
} from '@nucleus/user-ui';
import { TasksenseAppConfigAdapter } from './tasksense-app-config.adapter';
import { TasksenseUserNotifierAdapter } from './tasksense-notifier.adapter';
import { TasksenseUserSelfServiceAdapter } from './tasksense-user-self-service.adapter';
import { TasksenseUserServiceAdapter } from './tasksense-user.adapter';
import { TasksenseUserNavigatorAdapter } from './tasksense-navigator.adapter';

export * from './tasksense-app-config.adapter';
export * from './tasksense-notifier.adapter';
export * from './tasksense-user-self-service.adapter';
export * from './tasksense-user.adapter';
export * from './tasksense-navigator.adapter';

/**
 * Provider list for @nucleus/user-ui's contract tokens. Tasksense consumes
 * &lt;lib-my-profile&gt; (USER_SELF_SERVICE + APPLICATION_CONFIG + USER_NOTIFIER)
 * + &lt;lib-users-list&gt; / &lt;lib-user-edit&gt; (also USER_SERVICE +
 * USER_NAVIGATOR + USER_REPORT_FILENAME).
 *
 * NUC-294: the user lib gates on UserCaps codes via the shared
 * CAPABILITY_CHECKER (wired app-wide to PermissionsService); the old
 * USER_PERMISSIONS seam was removed in @nucleus/user-ui 0.0.39. Thin-shell
 * page-header buttons gate via `usersList.capabilities.hasCapability('user:…')`.
 */
export const NUCLEUS_USER_UI_PROVIDERS: Provider[] = [
  { provide: USER_SERVICE,         useExisting: TasksenseUserServiceAdapter },
  { provide: USER_SELF_SERVICE,    useExisting: TasksenseUserSelfServiceAdapter },
  { provide: APPLICATION_CONFIG,   useExisting: TasksenseAppConfigAdapter },
  { provide: USER_NOTIFIER,        useExisting: TasksenseUserNotifierAdapter },
  { provide: USER_NAVIGATOR,       useExisting: TasksenseUserNavigatorAdapter },
  { provide: USER_REPORT_FILENAME, useValue: 'tasksense-user-report' },
];
